import type {
    EccoAddBillingAddressToMyCartMutation,
    EccoAddBillingAddressToMyCartMutationVariables,
    EccoAddDeliveryAddressToMyCartMutation,
    EccoAddDeliveryAddressToMyCartMutationVariables,
    EccoAddDeliveryDateAndTimeSlotToCartMutationVariables,
    EccoAddShippingMethodToCartMutationVariables,
    EccoUpdateCartMutation,
    EccoUpdateCartMutationVariables,
    EccoUpdateLineItemSupplyChannelMutation,
    EccoUpdateLineItemSupplyChannelMutationVariables,
} from "@graphql/generated/types";

import { useCommerceToolsClient } from "@lib/commerce/adapters/commercetools/useCommerceToolsClient";
import { updateMutation } from "@store/helpers";
import { useStore } from "@store/store";

const useCartStore = () => {
    const setCartData = useStore((state) => state.setCart);
    return { setCartData };
};

export const useUpdateBillingAddress = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.eccoAddBillingAddressToMyCart;
    const { setCartData } = useCartStore();
    return updateMutation<
        EccoAddBillingAddressToMyCartMutationVariables,
        EccoAddBillingAddressToMyCartMutation
    >(executeWithVariables, setCartData);
};

export const useUpdateDeliveryAddress = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.eccoAddDeliveryAddressToMyCart;
    const { setCartData } = useCartStore();
    return updateMutation<
        EccoAddDeliveryAddressToMyCartMutationVariables,
        EccoAddDeliveryAddressToMyCartMutation
    >(executeWithVariables, setCartData);
};

export const useUpdateDeliveryDateAndTimeSlot = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.eccoAddDeliveryDateAndTimeSlotToCart;
    const { setCartData } = useCartStore();
    return updateMutation<EccoAddDeliveryDateAndTimeSlotToCartMutationVariables>(
        executeWithVariables,
        setCartData
    );
};

export const useAddShippingMethodToCart = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.eccoAddShippingMethodToCart;
    const { setCartData } = useCartStore();
    return updateMutation<EccoAddShippingMethodToCartMutationVariables>(
        executeWithVariables,
        setCartData
    );
};

export const useUpdateLineItemSupplyChannel = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.eccoUpdateLineItemSupplyChannel;
    const { setCartData } = useCartStore();
    return updateMutation<
        EccoUpdateLineItemSupplyChannelMutationVariables,
        EccoUpdateLineItemSupplyChannelMutation
    >(executeWithVariables, setCartData);
};

// Applies an arbitrary set of cart update actions in a single updateMyCart call — used to
// set the supply channel on every line item and to commit the whole checkout delivery step.
export const useUpdateCart = () => {
    const { client } = useCommerceToolsClient();
    const executeWithVariables = client.eccoUpdateCart;
    const { setCartData } = useCartStore();
    return updateMutation<EccoUpdateCartMutationVariables, EccoUpdateCartMutation>(
        executeWithVariables,
        setCartData
    );
};
